module.exports = __webpack_public_path__ + "img/CFvs420.ebbea4d4.png";